import React from "react";
import styled from "styled-components";
import CameraIcon from "mdi-react/CameraIcon";
import { Avatar } from "@material-ui/core";

export default function ProfilePic({ selectedImage, user, onPress }) {
  return (
    <React.Fragment>
      <ProfilePicture
        alt="Profile Picture"
        src={
          selectedImage
            ? URL.createObjectURL(selectedImage)
            : user && user.photo_url
        }
        style={{ marginVertical: 16 }}
        onClick={onPress}
      />
      <ProfilePictureWrapper>
        <CameraIcon color="#fff" />
      </ProfilePictureWrapper>
    </React.Fragment>
  );
}

const ProfilePicture = styled(Avatar)`
    && {
        height: 120px
        width: 120px
    }
`;

const ProfilePictureWrapper = styled.div`
    pointer-events: none
    display: flex
    position: absolute
    height: 120px
    width: 120px
    border-radius: 60px
    background-color: black
    opacity: 0.4
    justify-content: center
    align-items: center
`;
